import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEye, FaEyeSlash, FaPlus, FaTrash, FaArrowLeft } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";
import { GetUnRegisterCompanies } from "../../../Actions/CompanyActions";
import { SignUpMonazzam } from "../../../Actions/AuthorizationActions";
import { Spinner } from "react-bootstrap";
import { SuccessToast } from "../../../Util";

const Signup = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;

  const [step1Errors, setStep1Errors] = useState({});
  const [step2Errors, setStep2Errors] = useState({});
  const [step3Errors, setStep3Errors] = useState({});

  const [validationTriggered, setValidationTriggered] = useState(false);
  const [accountName, setAccountName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [enrollment, setEnrollment] = useState("");
  const [focalPerson, setFocalPerson] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // PKR Bank Accounts Step 2 - Dynamic array
  const [pkrAccounts, setPkrAccounts] = useState([
    {
      id: 1,
      pkrIban: "",
      pkrAccountTitle: "",
      pkrBankName: "",
      pkrBranchName: "",
      pkrSwiftCode: "",
    }
  ]);

  // FCY Account & E-Hajj Details Step 3
  const [fcyIban, setFcyIban] = useState("");
  const [fcyAccountTitle, setFcyAccountTitle] = useState("");
  const [fcyBankName, setFcyBankName] = useState("");
  const [fcyBranchName, setFcyBranchName] = useState("");
  const [fcySwiftCode, setFcySwiftCode] = useState("");
  const [eHajjIban, setEHajjIban] = useState("");

  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex =
    /^(?:\+?\d{1,3}[-.\s]?)?(?:\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;

  const getCurrentStepErrors = () => {
    const errors = (() => {
      switch (currentStep) {
        case 1: return step1Errors;
        case 2: return step2Errors;
        case 3: return step3Errors;
        default: return {};
      }
    })();
    
    
    return errors;
  };

  const navigate = useNavigate();

  useEffect(() => {
    GetUnRegisterCompanies(setCompanies);
  }, []);


  const addPkrAccount = () => {
    const newId = Math.max(...pkrAccounts.map(acc => acc.id), 0) + 1;
    setPkrAccounts([...pkrAccounts, {
      id: newId,
      pkrIban: "",
      pkrAccountTitle: "",
      pkrBankName: "",
      pkrBranchName: "",
      pkrSwiftCode: "",
    }]);
  };

  const removePkrAccount = (id) => {
    if (pkrAccounts.length > 1) {
      setPkrAccounts(pkrAccounts.filter(acc => acc.id !== id));
    }
  };

  const updatePkrAccount = (id, field, value) => {
    setPkrAccounts(pkrAccounts.map(acc => 
      acc.id === id ? { ...acc, [field]: value } : acc
    ));
    
    const errorKey = `${field}_${id}`;
    if (step2Errors[errorKey]) {
      setStep2Errors(prev => ({
        ...prev,
        [errorKey]: ""
      }));
    }
  };

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const validateStep = (step, setErrors = true) => {
    const errors = {};
    
    
    if (step === 1) {
    if (!accountName) errors.accountName = "Account Name is required.";
    else if (accountName.length < 2)
      errors.accountName = "Account name must be atleast 2 characters";
    if (!email || !emailRegex.test(email))
      errors.email = "Please enter a valid email address.";
    if (!phone) {
      errors.phone = "This field is required.";
    } else if (phone.length < 6 || !phoneRegex.test(phone)) {
      errors.phone = "Please enter a valid phone. With minimum 6 characters.";
    }
    if (!enrollment) errors.enrollment = "This field is required.";
      else if (enrollment.length !== 4)
        errors.enrollment = "Enrollment must be exactly 4 characters.";
    if (!focalPerson) {
      errors.focalPerson = "This field is required.";
    } else if (focalPerson.length < 2) {
        errors.focalPerson = "Focal Person name must be atleast 2 characters.";
    }
    if (!password) errors.password = "This field is required.";
    else if (password.length < 8) {
        errors.password = "Password must be atleast 8 characters.";
      }
      if (setErrors) setStep1Errors(errors);
    } else if (step === 2) {
      pkrAccounts.forEach((account, index) => {
        if (!account.pkrIban) errors[`pkrIban_${account.id}`] = "This field is required.";
        else if (account.pkrIban.length < 9)
          errors[`pkrIban_${account.id}`] = "PKR IBAN must be atleast 9 characters.";
        if (!account.pkrAccountTitle) errors[`pkrAccountTitle_${account.id}`] = "This field is required.";
        else if (account.pkrAccountTitle.length < 2)
          errors[`pkrAccountTitle_${account.id}`] = "Account Title must be atleast 2 characters.";
        if (!account.pkrBankName) errors[`pkrBankName_${account.id}`] = "This field is required.";
        else if (account.pkrBankName.length < 2)
          errors[`pkrBankName_${account.id}`] = "Bank name must be atleast 2 characters.";
        if (!account.pkrBranchName) errors[`pkrBranchName_${account.id}`] = "This field is required.";
        else if (account.pkrBranchName.length < 2)
          errors[`pkrBranchName_${account.id}`] = "Branch name must be atleast 2 characters.";
        if (!account.pkrSwiftCode) errors[`pkrSwiftCode_${account.id}`] = "This field is required.";
        else if (account.pkrSwiftCode.length < 4)
          errors[`pkrSwiftCode_${account.id}`] = "PKR Swift code must be atleast 4 characters.";
      });
      if (setErrors) setStep2Errors(errors);
    } else if (step === 3) {
    if (!fcyIban) errors.fcyIban = "This field is required.";
    else if (fcyIban.length < 9)
        errors.fcyIban = "FCY IBAN must be atleast 9 characters.";
    if (!fcyAccountTitle) errors.fcyAccountTitle = "This field is required.";
    else if (fcyAccountTitle.length < 2)
        errors.fcyAccountTitle = "Account title must be atleast 2 characters.";
    if (!fcyBankName) errors.fcyBankName = "This field is required.";
    else if (fcyBankName.length < 2)
        errors.fcyBankName = "Bank name must be atleast 2 characters.";
    if (!fcyBranchName) errors.fcyBranchName = "This field is required.";
    else if (fcyBranchName.length < 2)
        errors.fcyBranchName = "Branch name must be atleast 2 characters.";
    if (!fcySwiftCode) errors.fcySwiftCode = "This field is required.";
    else if (fcySwiftCode.length < 4)
        errors.fcySwiftCode = "FCY Swift code must be atleast 4 characters.";
      if (!eHajjIban) errors.eHajjIban = "This field is required.";
      else if (eHajjIban.length < 7) {
        errors.eHajjIban = "E-Hajj IBAN must be atleast 7 characters.";
      }
      if (setErrors) setStep3Errors(errors);
    }
    
    return Object.keys(errors).length === 0;
  };

  const validateAllFields = () => {
    return validateStep(1, false) && validateStep(2, false) && validateStep(3, false);
  };

  const handleInputChange = (setter, fieldName) => (e) => {
    e.preventDefault();
    setter(e.target.value);
    
    if (fieldName) {
      if (currentStep === 1 && step1Errors[fieldName]) {
        setStep1Errors(prev => ({
          ...prev,
          [fieldName]: ""
        }));
      } else if (currentStep === 2 && step2Errors[fieldName]) {
        setStep2Errors(prev => ({
          ...prev,
          [fieldName]: ""
        }));
      } else if (currentStep === 3 && step3Errors[fieldName]) {
        setStep3Errors(prev => ({
          ...prev,
          [fieldName]: ""
        }));
      }
    }
  };

  const handleSignupSuccess = () => {
    SuccessToast("Signup successful!");
    setAccountName("");
    setEnrollment("");
    setEmail("");
    setPhone("");
    setFocalPerson("");
    setPassword("");
    setPkrAccounts([{
      id: 1,
      pkrIban: "",
      pkrAccountTitle: "",
      pkrBankName: "",
      pkrBranchName: "",
      pkrSwiftCode: "",
    }]);
    setFcyIban("");
    setFcyAccountTitle("");
    setFcyBankName("");
    setFcyBranchName("");
    setFcySwiftCode("");
    setEHajjIban("");
    setStep1Errors({});
    setStep2Errors({});
    setStep3Errors({});
    setValidationTriggered(false);
    setCurrentStep(1);
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  const handleNext = () => {
    const isValid = validateStep(currentStep, true);
    setValidationTriggered(true);
    
    if (isValid) {
      nextStep();
      setTimeout(() => setValidationTriggered(false), 0);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValidationTriggered(true);
    
    const step1Valid = validateStep(1, true);
    const step2Valid = validateStep(2, true);
    const step3Valid = validateStep(3, true);
    
    if (!step1Valid || !step2Valid || !step3Valid) {
      setLoading(false);
      return;
    } else {
      const bankAccounts = pkrAccounts.map(account => ({
        iban: account.pkrIban,
        accountTitle: account.pkrAccountTitle,
        bankName: account.pkrBankName,
        branchName: account.pkrBranchName,
        swiftCode: account.pkrSwiftCode
      }));
      
      const signupData = {
        companyId: accountName,
        enrollment,
        email,
        phone,
        focalPerson,
        password,
        bankAccounts,
        fcyIban,
        fcyAccountTitle,
        fcyBankName,
        fcyBranchName,
        fcySwiftCode,
        eHajjIban,
      };
      SignUpMonazzam(
        signupData,
        setError,
        setLoading,
        setSuccessMessage,
        handleSignupSuccess
      );
    }
  };

  return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', paddingTop: '40px', paddingBottom: '40px' }}>
        <div style={{ maxWidth: "620px", width: "100%" }}>
        <div className="text-center mb-4">
            <img src="/assets/logo.png" alt="Logo" className="img-fluid logo mb-3" />
            <h2 className="mt-3" style={{ fontSize: "18px" , fontWeight: 800, fontFamily: "Inter" }}>Create Your Account</h2>
            <p style={{
              fontFamily: 'Inter',
              fontWeight: 300,
              fontSize: '10px',
              lineHeight: '100%',
              letterSpacing: '0%',
              color: '#9FA6B2'
            }}>Join our Hajj organization management platform</p>
        </div>

          <form
            onSubmit={(e) => e.preventDefault()}
            className="bg-white rounded"
            style={{ 
              position: "relative",
              boxShadow: "0px 0px 4px 0px #00000050",
              padding: "20px 85px",
              width: "100%"
            }}
          >
          {currentStep > 1 && (
            <button
              type="button"
              className="btn"
              onClick={prevStep}
              style={{
                width: "71px",
                height: "31px",
                borderRadius: "10px",
                color: "black",
                backgroundColor: "white",
                border: "1px solid #9FA6B2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
                fontSize: "12px",
                fontWeight: "400",
                position: "absolute",
                top: "25px",
                left: "25px",
                transition: "all 0.2s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#9FA6B2";
                e.target.style.color = "white";
                e.target.style.borderColor = "#9FA6B2";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "black";
                e.target.style.borderColor = "#9FA6B2";
              }}
            >
              <FaArrowLeft style={{ fontSize: "8px" }} />
              Back
            </button>
          )}

           {currentStep === 1 && (
             <div>
               <h4 className="text-center mb-3" style={{
                 fontFamily: 'Inter',
                 fontWeight: 600,
                 fontSize: '14px',
                 lineHeight: '100%',
                 letterSpacing: '0%',
                 color: '#019440'
               }}>Basic Information</h4>
               <p className="text-center mb-4" style={{
                 fontFamily: 'Inter',
                 fontWeight: 300,
                 fontSize: '11px',
                 lineHeight: '100%',
                 letterSpacing: '0%',
                 color: '#9FA6B2'
               }}>Let's start with your basic company and contact information</p>
          <div className="form-group mb-3">
                <label className="label-text">Monazam Account Name <span className="text-danger">*</span></label>
                <div className="position-relative">
            <select
              className={`form-control input-style ${
                getCurrentStepErrors().accountName ? "border-danger" : ""
              }`}
                    style={{ maxWidth: "520px" }}
              value={accountName}
                    onChange={handleInputChange(setAccountName, 'accountName')}
            >
                    <option value="">Company Name</option>
              {companies.length > 0 ? (
                companies.map((company, index) => (
                  <option key={index} value={company.id}>
                    {company.name}
                  </option>
                ))
              ) : (
                <option value="">No companies available</option>
              )}
            </select>
                  <span className="position-absolute end-0 top-50 translate-middle-y me-2">
                    <i className="fas fa-chevron-down text-muted"></i>
                  </span>
          </div>
            {getCurrentStepErrors().accountName && (
                  <small className="text-danger error-text">{getCurrentStepErrors().accountName}</small>
            )}
          </div>
               <div className="row mb-3">
                 <div className="col-md-6">
                   <div className="form-group">
                     <label className="label-text">Email <span className="text-danger">*</span></label>
              <input
                type="email"
                className={`form-control input-style ${
                  getCurrentStepErrors().email ? "border-danger" : ""
                }`}
                       placeholder="ali@gmail.com"
                value={email}
                       onChange={handleInputChange(setEmail, 'email')}
              />
              {getCurrentStepErrors().email && (
                       <small className="text-danger error-text">{getCurrentStepErrors().email}</small>
              )}
            </div>
                 </div>
                 <div className="col-md-6">
                   <div className="form-group">
                     <label className="label-text">Phone Number <span className="text-danger">*</span></label>
              <input
                type="tel"
                className={`form-control input-style ${
                  getCurrentStepErrors().phone ? "border-danger" : ""
                }`}
                       placeholder="(+237) 696 88 77 55"
                value={phone}
                       onChange={handleInputChange(setPhone, 'phone')}
              />
              {getCurrentStepErrors().phone && (
                       <small className="text-danger error-text">{getCurrentStepErrors().phone}</small>
              )}
                   </div>
            </div>
          </div>
          <div className="form-group mb-3">
                 <label className="label-text">Focal Person <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                getCurrentStepErrors().focalPerson ? "border-danger" : ""
              }`}
                   style={{ maxWidth: "520px" }}
                   placeholder="Name"
              value={focalPerson}
                   onChange={handleInputChange(setFocalPerson, 'focalPerson')}
            />
            {getCurrentStepErrors().focalPerson && (
                  <small className="text-danger error-text">{getCurrentStepErrors().focalPerson}</small>
                )}
              </div>
              <div className="form-group mb-3">
                 <label className="label-text">Enrollment Number <span className="text-danger">*</span></label>
                 <input
                   type="text"
                   className={`form-control input-style ${
                     getCurrentStepErrors().enrollment ? "border-danger" : ""
                   }`}
                   style={{ maxWidth: "520px" }}
                   placeholder="For Ex: xxxx)"
                   value={enrollment}
                   onChange={handleInputChange(setEnrollment, 'enrollment')}
                 />
                {getCurrentStepErrors().enrollment && (
                  <small className="text-danger error-text">{getCurrentStepErrors().enrollment}</small>
            )}
          </div>
          <div className="form-group mb-3">
                 <label className="label-text">Password <span className="text-danger">*</span></label>
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className={`form-control input-style ${
                  getCurrentStepErrors().password ? "border-danger" : ""
                }`}
                     style={{ maxWidth: "520px" }}
                     placeholder="Enter your password"
                value={password}
                     onChange={handleInputChange(setPassword, 'password')}
              />
              <span
                className="position-absolute end-0 top-50 translate-middle-y me-2"
                onClick={() => setShowPassword(!showPassword)}
                style={{ cursor: "pointer" }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {getCurrentStepErrors().password && (
                    <small className="text-danger error-text">{getCurrentStepErrors().password}</small>
                )}
              </div>
            </div>
          )}

           {currentStep === 2 && (
             <div>
              <h4 className="" style={{
                fontFamily: 'Inter',
                fontWeight: 600,
                fontSize: '16px',
                color: '#019440',
                textAlign: 'center'
              }}>PKR Bank Accounts</h4>
              <p className="mb-4" style={{
                fontFamily: 'Inter',
                fontWeight: 300,
                fontSize: '10px',
                lineHeight: '13px',
                letterSpacing: '0px',
                color: '#9FA6B2',
                textAlign: 'center'
              }}>Add your PKR bank account details. You can add multiple accounts.</p>
              
              {pkrAccounts.map((account, index) => (
                <div key={account.id} className="rounded px-3 pt-3 mb-3 position-relative" style={{ borderColor: '#019440', borderWidth: '1px', borderStyle: 'solid' }}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0" style={{
                      fontFamily: 'Inter',
                      fontWeight: 600,
                      fontSize: '14px',
                      color: '#000000'
                    }}>
                      <img src="/assets/bank_account.png" alt="Bank Account" width="18" height="18" className="me-2" />
                      PKR Bank Account #{index + 1}
                    </h6>
                    {pkrAccounts.length > 1 && (
                      <button
                        type="button"
                        className="btn"
                        onClick={() => removePkrAccount(account.id)}
                        style={{
                          backgroundColor: "white",
                          border: "1px solid #dc3545",
                          color: "#dc3545",
                          borderRadius: "8px",
                          padding: "6px 12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          transition: "all 0.2s ease"
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#dc3545";
                          e.target.style.color = "white";
                          e.target.style.borderColor = "#dc3545";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "white";
                          e.target.style.color = "#dc3545";
                          e.target.style.borderColor = "#dc3545";
                        }}
                      >
                        <FaTrash style={{ fontSize: "10px" }} />
                        Remove
                      </button>
            )}
          </div>
                  
          <div className="form-group mb-3">
                    <label className="label-text">PKR IBAN <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                        getCurrentStepErrors()[`pkrIban_${account.id}`] ? "border-danger" : ""
                      }`}
                      style={{ maxWidth: "520px" }}
                      placeholder="IBAN Number"
                      value={account.pkrIban}
                      onChange={(e) => updatePkrAccount(account.id, 'pkrIban', e.target.value)}
                    />
                    {getCurrentStepErrors()[`pkrIban_${account.id}`] && (
                      <small className="text-danger error-text">{getCurrentStepErrors()[`pkrIban_${account.id}`]}</small>
            )}
          </div>

          <div className="form-group mb-3">
                    <label className="label-text">PKR Account Title <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                        getCurrentStepErrors()[`pkrAccountTitle_${account.id}`] ? "border-danger" : ""
                      }`}
                      style={{ maxWidth: "520px" }}
                      placeholder="Name"
                      value={account.pkrAccountTitle}
                      onChange={(e) => updatePkrAccount(account.id, 'pkrAccountTitle', e.target.value)}
                    />
                    {getCurrentStepErrors()[`pkrAccountTitle_${account.id}`] && (
                      <small className="text-danger error-text">{getCurrentStepErrors()[`pkrAccountTitle_${account.id}`]}</small>
            )}
          </div>

          <div className="form-group mb-3">
                    <label className="label-text">PKR Bank Name <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                        getCurrentStepErrors()[`pkrBankName_${account.id}`] ? "border-danger" : ""
                      }`}
                      style={{ maxWidth: "520px" }}
                      placeholder="Name"
                      value={account.pkrBankName}
                      onChange={(e) => updatePkrAccount(account.id, 'pkrBankName', e.target.value)}
                    />
                    {getCurrentStepErrors()[`pkrBankName_${account.id}`] && (
                      <small className="text-danger error-text">{getCurrentStepErrors()[`pkrBankName_${account.id}`]}</small>
            )}
          </div>

                  <div className="row">
                    <div className="col-md-6">
          <div className="form-group mb-3">
                        <label className="label-text">PKR Branch Name <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                            getCurrentStepErrors()[`pkrBranchName_${account.id}`] ? "border-danger" : ""
                          }`}
                          placeholder="Name"
                          value={account.pkrBranchName}
                          onChange={(e) => updatePkrAccount(account.id, 'pkrBranchName', e.target.value)}
                        />
                        {getCurrentStepErrors()[`pkrBranchName_${account.id}`] && (
                          <small className="text-danger error-text">{getCurrentStepErrors()[`pkrBranchName_${account.id}`]}</small>
            )}
          </div>
                    </div>
                    <div className="col-md-6">
          <div className="form-group mb-3">
                        <label className="label-text">PKR Swift Code <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                            getCurrentStepErrors()[`pkrSwiftCode_${account.id}`] ? "border-danger" : ""
                          }`}
                          placeholder="Code"
                          value={account.pkrSwiftCode}
                          onChange={(e) => updatePkrAccount(account.id, 'pkrSwiftCode', e.target.value)}
                        />
                        {getCurrentStepErrors()[`pkrSwiftCode_${account.id}`] && (
                          <small className="text-danger error-text">{getCurrentStepErrors()[`pkrSwiftCode_${account.id}`]}</small>
            )}
          </div>
                    </div>
                  </div>
                </div>
              ))}
              
              <div className="rounded p-3 mb-3 text-center" style={{ borderColor: '#019440', borderWidth: '1px', borderStyle: 'dashed' }}>
                <button
                  type="button"
                  style={{
                    border: "1px solid #019440",
                    color: "#019440",
                    backgroundColor: "white",
                    fontWeight: 500,
                    fontSize: "10px",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    transition: "background-color 0.15s",
                  }}
                  onClick={addPkrAccount}
                >
                  <FaPlus className="me-2" />
                  Add another PKR Bank Account
                </button>
                <p className="mt-2 mb-0" style={{
                fontFamily: 'Inter',
                fontWeight: 300,
                fontSize: '10px',
                lineHeight: '13px',
                letterSpacing: '0px',
                color: '#9FA6B2',
                textAlign: 'center'
              }}>You can add multiple bank accounts for better flexibility</p>
              </div>
            </div>
          )}

           {currentStep === 3 && (
             <div>
               <h4 className="mb-3" style={{
                 fontFamily: 'Inter',
                 fontWeight: 600,
                 fontSize: '16px',
                 lineHeight: '100%',
                 letterSpacing: '0%',
                 color: '#019440',
                 textAlign: 'center'
               }}>FCY Account & E-Hajj Details</h4>
               <p className="mb-4" style={{
                 fontFamily: 'Inter',
                 fontWeight: 300,
                 fontSize: '11px',
                 lineHeight: '100%',
                 letterSpacing: '0%',
                 color: '#9FA6B2',
                 textAlign: 'center'
               }}>Complete your account setup with FCY and E-Hajj information.</p>
              
              <div className="border border-success rounded p-3 mb-3">
                <h6 className="mb-3" style={{
                  fontFamily: 'Inter',
                  fontWeight: 600,
                  fontSize: '14px',
                  color: '#000000'
                }}>
                  <img src="/assets/fcy.png" alt="FCY Account" width="18" height="18" className="me-2" />
                  FCY Account Details
                </h6>
                
                <div className="row mb-0">
                  <div className="col-md-6 mb-3">
                    <label className="label-text">FCY IBAN <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                getCurrentStepErrors().fcyIban ? "border-danger" : ""
              }`}
                      placeholder="IBAN Number"
              value={fcyIban}
                      onChange={handleInputChange(setFcyIban, 'fcyIban')}
            />
            {getCurrentStepErrors().fcyIban && (
                      <small className="text-danger error-text">{getCurrentStepErrors().fcyIban}</small>
            )}
          </div>
                  <div className="col-md-6 mb-3">
                    <label className="label-text">FCY Account Title <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                getCurrentStepErrors().fcyAccountTitle ? "border-danger" : ""
              }`}
                      placeholder="Name"
              value={fcyAccountTitle}
                      onChange={handleInputChange(setFcyAccountTitle, 'fcyAccountTitle')}
            />
            {getCurrentStepErrors().fcyAccountTitle && (
                      <small className="text-danger error-text">{getCurrentStepErrors().fcyAccountTitle}</small>
            )}
          </div>
                  <div className="col-md-6 mb-3">
                    <label className="label-text">FCY Bank Name <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                getCurrentStepErrors().fcyBankName ? "border-danger" : ""
              }`}
                      placeholder="Name"
              value={fcyBankName}
                      onChange={handleInputChange(setFcyBankName, 'fcyBankName')}
            />
            {getCurrentStepErrors().fcyBankName && (
                      <small className="text-danger error-text">{getCurrentStepErrors().fcyBankName}</small>
            )}
          </div>
                  <div className="col-md-6 mb-3">
                    <label className="label-text">FCY Branch Name <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                getCurrentStepErrors().fcyBranchName ? "border-danger" : ""
              }`}
                      placeholder="Name"
              value={fcyBranchName}
                      onChange={handleInputChange(setFcyBranchName, 'fcyBranchName')}
            />
            {getCurrentStepErrors().fcyBranchName && (
                      <small className="text-danger error-text">{getCurrentStepErrors().fcyBranchName}</small>
            )}
          </div>
                  <div className="col-md-6">
                    <label className="label-text">FCY Swift Code <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                getCurrentStepErrors().fcySwiftCode ? "border-danger" : ""
              }`}
                      placeholder="Code"
              value={fcySwiftCode}
                      onChange={handleInputChange(setFcySwiftCode, 'fcySwiftCode')}
            />
            {getCurrentStepErrors().fcySwiftCode && (
                      <small className="text-danger error-text">{getCurrentStepErrors().fcySwiftCode}</small>
            )}
          </div>
                </div>
              </div>
              
              <div className="border border-success rounded p-3 mb-3">
                <h6 className="mb-3" style={{
                  fontFamily: 'Inter',
                  fontWeight: 600,
                  fontSize: '14px',
                  color: '#000000'
                }}>
                  <img src="/assets/fcy.png" alt="E-Hajj Account" width="18" height="18" className="me-2" />
                  E-Hajj Account
                </h6>
                
                <div className="row mb-0">
                  <div className="col-md-6">
                    <label className="label-text">E-Hajj IBAN <span className="text-danger">*</span></label>
            <input
              type="text"
              className={`form-control input-style ${
                getCurrentStepErrors().eHajjIban ? "border-danger" : ""
              }`}
                      placeholder="IBAN Number"
              value={eHajjIban}
                      onChange={handleInputChange(setEHajjIban, 'eHajjIban')}
            />
            {getCurrentStepErrors().eHajjIban && (
                      <small className="text-danger error-text">{getCurrentStepErrors().eHajjIban}</small>
            )}
          </div>
                </div>
              </div>
            </div>
          )}

          <div className="">
             <div>
               {currentStep < totalSteps ? (
                 <button
                   type="button"
                   className="btn"
                   onClick={handleNext}
                   style={{
                     backgroundColor: '#00341A',
                     width: '100%',
                     border: 'none',
                     fontFamily: 'Inter',
                     fontWeight: 300,
                     fontSize: '12px',
                     color: '#FFFFFF'
                   }}
                 >
                   Next
                 </button>
               ) : (
          <button
            type="button"
                   className="btn"
            disabled={loading}
                   onClick={handleSignup}
                   style={{
                     backgroundColor: '#00341A',
                     width: '100%',
                     border: 'none',
                     fontFamily: 'Inter',
                     fontWeight: 300,
                     fontSize: '12px',
                     color: '#FFFFFF'
                   }}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Sign Up"
            )}
          </button>
               )}
             </div>
          </div>
        </form>
          
        <div className="text-center mt-3">
          <span className="label-text">Already have an account? </span>
          <Link to="/" className="text-decoration-none lightgreen-txt">
            Login Here
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Signup;
